module.exports = __webpack_public_path__ + "static/media/taxes.a311ae34.svg";